let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9bIA3")).then(() => parcelRequire('3ZKV6'));